/* Shared vanilla-lazyload bootstrap for the ss-* sections. */
(function () {
  'use strict';
  function init() {
    if (typeof window.LazyLoad === 'undefined') return;
    if (window.lazyLoadInstance && typeof window.lazyLoadInstance.update === 'function') {
      window.lazyLoadInstance.update();
    } else {
      window.lazyLoadInstance = new window.LazyLoad();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
